import {
    PaymentProviderInterface
} from '@/components/classes/PaymentProviders/Deposit/Interfaces/PaymentProviderInterface';
import PaymentProvider, {
    PaymentProviderConstructor,
} from '@/components/classes/PaymentProviders/Deposit/PaymentProvider';
import {PaymentProvider as PaymentProviderConstant} from '@/constants/paymentProvider';
import {aircashGetPaymentLink} from '@/modules/casino/store/actions/deposit';
import cordovaRedirect from '../../utils/cordovaRedirect';

/**
 * @deprecated
 */
class AircashPay extends PaymentProvider implements PaymentProviderInterface {
    constructor(data: PaymentProviderConstructor) {
        super(data);
        this.setType(PaymentProviderConstant.aircash_pay);
    }

    init(data: any): void {
        super.init(data);
    }

    confirmPayment(): void {
        this.dispatch(aircashGetPaymentLink({...this.paymentDetails,paymentMethod: 'aircash-pay'}));
    }

    redirect(url: string): void {
        if (window.config.cordova) {
            this.openedPopupUrl = cordovaRedirect(url, this.openedPopupUrl);
            return;
        }
        window.location.href = url;
    }
}

export default AircashPay;
